// src/services/api/procurement/supplierPayment.js
// Endpoints per rettzy-backend/src/modules/procurement/routes/supplierPayment.routes.js
// Write-path UI (Record Payment modal) is wired in Phase 11 — service surface added now.
import { apiClient } from '../base';

export const recordSupplierPayment = async (data) => {
  const response = await apiClient.post('/procurement/supplier-payments', data);
  return response.data;
};

export const getPaymentsForPurchaseOrder = async (purchaseOrderId) => {
  const response = await apiClient.get('/procurement/supplier-payments', { params: { purchaseOrderId } });
  return response.data;
};

export const getSupplierPaymentById = async (paymentId) => {
  const response = await apiClient.get(`/procurement/supplier-payments/${paymentId}`);
  return response.data;
};

export const recordPurchaseOrderPayments = async (purchaseOrderId, payments) => {
  const response = await apiClient.post(`/procurement/supplier-payments/purchase-orders/${purchaseOrderId}`, { payments });
  return response.data;
};

export const updateSupplierPayment = async (paymentId, data) => {
  const response = await apiClient.patch(`/procurement/supplier-payments/${paymentId}`, data);
  return response.data;
};

export const getProcurementPaymentMethods = async () => {
  const response = await apiClient.get('/procurement/supplier-payments/payment-methods');
  return response.data;
};
